import React from "react";
import { Container } from "react-bootstrap";
import Link from "../components/Link";
import WpImage from "../components/WpImage";

// Logos are fitted into the same box, so wide and tall marks look balanced.
const LOGO_MAX_WIDTH = 150;
const LOGO_MAX_HEIGHT = 30;

const logoWidth = (image) => {
    const data = image?.localFile?.childImageSharp?.gatsbyImageData;
    if (!data?.width || !data?.height) return undefined;

    return Math.round(
        Math.min(LOGO_MAX_WIDTH, (LOGO_MAX_HEIGHT * data.width) / data.height)
    );
};

const NetworkConnectors = ({
    category,
    header,
    text,
    link,
    logos,
    moreValue,
    moreLabel,
    className,
}) => {
    const images = logos?.filter(({ image }) => image) || [];
    const hasMore = !!(moreValue || moreLabel);

    if (!header && images.length === 0) return null;

    return (
        <section className={`network-connectors ${className || ""}`}>
            <Container className="network-connectors__grid">
                <div className="network-connectors__copy">
                    {category && (
                        <p
                            className="network-connectors__label"
                            dangerouslySetInnerHTML={{ __html: category }}
                        />
                    )}
                    {header && (
                        <h2
                            className="network-connectors__header"
                            dangerouslySetInnerHTML={{ __html: header }}
                        />
                    )}
                    {text && (
                        <p
                            className="network-connectors__text"
                            dangerouslySetInnerHTML={{ __html: text }}
                        />
                    )}
                    {link?.url && link?.title && (
                        <Link link={link} className="network-connectors__link">
                            {link.title}
                            <span aria-hidden="true">&#8594;</span>
                        </Link>
                    )}
                </div>

                {(images.length > 0 || hasMore) && (
                    <div className="network-connectors__logos">
                        <ul className="network-connectors__cells">
                            {images.map(({ image }, index) => (
                                <li
                                    className="network-connectors__cell"
                                    key={index}
                                >
                                    <span
                                        className="network-connectors__logo"
                                        style={{ width: logoWidth(image) }}
                                    >
                                        <WpImage image={image} />
                                    </span>
                                </li>
                            ))}
                            {hasMore && (
                                <li className="network-connectors__cell -more">
                                    {moreValue && <b>{moreValue}</b>}
                                    {moreLabel && <span>{moreLabel}</span>}
                                </li>
                            )}
                        </ul>
                    </div>
                )}
            </Container>
        </section>
    );
};

export default NetworkConnectors;
